import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Authentication } from '@technocom/auth';
import { AuthorityClaim } from '@technocom/auth/lib/models/authority-claim';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private user: Authentication, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requirements = route.data.requirements as AuthorityClaim;
    const authorized = route.data.authorized && this.user.isAuthenticated();
    if (!this.user.canAccess(requirements) || authorized) {
      return this.router.createUrlTree(['/']);
    }
    return true;
  }
}
